<div class="card card-outline card-primary">
  <div class="card-header text-center">
    <a [routerLink]="['/']" class="h1">
      <img src="assets/img/logo.png" alt="" class="img-fluid">
    </a>
  </div>
  <div class="card-body">
    <!-- <p class="login-box-msg">Sign in</p> -->

    <form [formGroup]="loginForm" (ngSubmit)="loginByAuth()" *ngIf="isEmailAuthEnabled">
      <div class="input-group mb-3">
        <input formControlName="email" type="email" class="form-control" placeholder="Email" />
        <div class="input-group-append">
          <div class="input-group-text">
            <span class="fas fa-envelope"></span>
          </div>
        </div>
      </div>
      <div class="input-group mb-3">
        <input formControlName="password" type="password" class="form-control" placeholder="Password" />
        <div class="input-group-append">
          <div class="input-group-text">
            <span class="fas fa-lock"></span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-7">
          <div class="icheck-primary">
            <input type="checkbox" id="remember" />
            <label for="remember"> Remember Me </label>
          </div>
        </div>
        <!-- /.col -->
        <div class="col-5">
          <button class="btn btn-primary btn-block" [disabled]="ismicrosoftLoading || isGoogleLoading" (click)="loginByAuth()">
            Sign In
          </button>
        </div>
        <!-- /.col -->
      </div>
    </form>

    <div class="social-auth-links text-center mb-3">
      <button class="mb-2 btn btn-block btn-secondary" [disabled]="isAuthLoading || isGoogleLoading" (click)="loginByMicrosoft()">
        <img src="assets/img/ms-symbollockup_signin_dark.png" alt="Sign in using Micorsoft">
      </button>
    </div>

    <!-- These are not needed -->
    <!-- <p class="mb-1">
      <a [routerLink]="['/forgot-password']">I forgot my password</a>
    </p>
    <p class="mb-0">
      <a [routerLink]="['/register']" class="text-center">
        Register a new membership
      </a>
    </p> -->
  </div>
</div>
